<template>
  <ul class="navigation-items">
    <li>
      <a v-scroll-to="setScrollSettings('cars')">Nabídka</a>
    </li>
    <li>
      <a v-scroll-to="setScrollSettings('about')">Služby</a>
    </li>
    <li>
      <a v-scroll-to="setScrollSettings('contacts')">Kontakty</a>
    </li>
  </ul>
</template>
<script>
export default {
  methods: {
    setScrollSettings(el) {
      return {
        el: "#" + el
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/global.scss";
.navigation-items {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  li {
    a {
      margin: 1rem 0;
      padding: 0.2rem 0;
      display: inline-block;
      text-decoration: none;
      padding-bottom: 1rem;
      border-bottom: 4px solid transparent;
      font-size: 1rem;
      font-weight: 700;
      text-transform: uppercase;
      cursor: pointer;
      color: rgb(71, 71, 71);
      &:hover {
        border-bottom: 4px solid rgb(49, 48, 48);
        color: rgb(49, 48, 48);
      }
    }
  }
}
@media (min-width: $min-width-extended) {
  .navigation-items {
    flex-direction: row;
    li {
      a {
        margin: 0 1rem;
        padding: 0 0.2rem;
        padding-bottom: 1rem;
      }
    }
  }
}
</style>
